import React, { useState, useContext, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Alert } from "../../shared";
import avatar from "../../assets/images/plant.svg";
import ShortcutModal from "../ShortcutModal";
import { UsersDevice, Users, AllUsers, HomeEdit } from "./";
import { ProfileSection } from "../../context/ProfileContext";
import {
  invitationNewApi,
  deviceMineApi,
  dashboardZone,
  zoneWidgets,
} from "../../api";
import {
  setNewInvitation,
  setDeviceMine,
  setDashboardZone,
  setDashboardDetails,
  setZoneWidgets,
} from "../../redux";
import { withRouter } from "react-router-dom";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";

const ProfileFirstPageComp = (x) => {
  const { t } = useTranslation();
  const { props, props22 } = x;
  console.log(props22);
  const { deviceMine } = useContext(DeviceMineContext);
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const form = useRef();
  const [openAddUser, setOpenAddUser] = useState(false);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showHomeEdit, setShowHomeEdit] = useState(false);
  const userInfo = useSelector((state) => state.userProfileInfo);
  const invitationList = useSelector(
    (state) => state.invitationList.invitationList
  );
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  let [activeIndex, setActiveIndex] = useState(0);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  const initialValues = {
    name: "",
    email: "",
  };

  const submitForm = () => {
    const data = new FormData(form.current);
    invitationNewApi(data, token)
      .then((res) => {
        dispatch(setNewInvitation(res.data.data));
        setOpenAddUser(!openAddUser);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    name: Yup.string().required(t("نام را وارد کنید.")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
  });

  const getDevices = () => {
    deviceMineApi(token)
      .then((res) => {
        // console.log(res);
        dispatch(setDeviceMine(res.data.data));
        ProfileShowHideFunc("deviceMine");
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => {
            dispatch(setZoneWidgets(res.data.data));
          })
          .catch(() => {
            dispatch(setZoneWidgets([]));
          });
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  // const deleteDashboard = (id) => {
  //   setShowAlert((prevState) => ({
  //     ...prevState,
  //     show: true,
  //     message: "آیا از حذف این خانه اطمینان دارید؟",
  //     type: "Warning",
  //     question: true,
  //     id: id,
  //     request: "dashboard",
  //   }));
  // };
  const deleteDashboard = async (id) => {
    let countDevice = 0;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    try {
      var formdata = new FormData();
      formdata.append("dashboard", id);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let response = await fetch(
        "https://assessn.mmaviot.com/api/dashboard_zones",
        requestOptions
      );
      let result = await response.json();

      for (const zone of result.data) {
        let formdataZone = new FormData();
        formdataZone.append("zone", zone.id);
        let requestOptionsZone = {
          method: "POST",
          headers: myHeaders,
          body: formdataZone,
          redirect: "follow",
        };

        let responseZone = await fetch(
          "https://assessn.mmaviot.com/api/zone_widgets",
          requestOptionsZone
        );
        let resultZone = await responseZone.json();

        if (resultZone.data.length !== 0) {
          countDevice++;
        }
      }

      if (countDevice === 0) {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("آیا از حذف این ساختمان اطمینان دارید؟"),
          type: "Warning",
          question: true,
          id: id,
          request: "dashboard",
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      } else {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t(
            "این ساختمان حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
          ),
          type: "Warning",
          question: false,
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <>
      {!showHomeEdit ? (
        <>
          <div
            className="d-flex flex-column align-items-center mb-2"
            style={{ height: "18vh" }}
          >
            <img
              src={
                userInfo.image !== ""
                  ? "https://assessn.mmaviot.com" + userInfo.image
                  : avatar
              }
              width="60"
              height="60"
              className="rounded-circle"
            />
            <p className="my-1 fn">{userInfo.name}</p>
            <p className="fn12">{userInfo.email}</p>
          </div>
          <div style={{ minHeight: "25vh" }}>
            <div className="d-flex justify-content-between">
              {/* <UsersDevice name="خانه" count="2" />
                    <UsersDevice name="دستگاه" count="23" /> */}
              <div
                className="profileDevice py-2 bg-white mb-3 d-flex align-items-center cursor"
                onClick={() => setShowDashboard(!showDashboard)}
              >
                <div className="profileDeviceIcon bg-white mx-2 d-flex align-items-center justify-content-center">
                  <i className="icon-house"></i>
                </div>
                <div className="text-right">
                  <p className="m-0 fn12">{t("خانه")}</p>
                  <small className="fn10">
                    {userInfo.dashboard_count === 1
                      ? `${userInfo.dashboard_count} ${t("عدد")}`
                      : `${userInfo.dashboard_count} ${t("اعداد")}`}
                  </small>
                </div>
              </div>
              <div
                className="profileDevice py-2 bg-white mb-3 d-flex align-items-center cursor"
                onClick={getDevices}
              >
                <div className="profileDeviceIcon bg-white mx-2 d-flex align-items-center justify-content-center">
                  <i className="icon-plug"></i>
                </div>
                <div className="text-right">
                  <p className="m-0 fn12">{t("دستگاه")}</p>
                  <small className="fn10">
                    {deviceMine.length === 1
                      ? `${deviceMine.length} ${t("عدد")}`
                      : `${deviceMine.length} ${t("اعداد")}`}
                  </small>
                </div>
              </div>
            </div>
            {showDashboard && (
              <div className="position-relative">
                <div
                  className="dashboard position-relative d-flex align-items-center"
                  style={{ borderRadius: "0", height: "8vh" }}
                ></div>
                <div className="dashboardElm position-absolute d-flex">
                  {/* <span className="dashbordBtn d-block fn bgWhite mr-3 ml-2 cursor text-center"
                                        onClick={() => setShowHomeEdit(true)}>خونه من</span>
                                    <span className="dashbordBtn d-block fn bgBlur mx-2 text-center cursor text-white">خونه شمال</span>
                                    <span className="dashbordIcon mx-2 text-center text-white cursor icon-combined-shape"
                                        style={{ fontSize: '18px' }}
                                    ></span> */}

                  {dashboardMine?.map((dash, index) => {
                    const active = activeIndex === index ? true : false;
                    return (
                      <span
                        className={`dashbordBtn position-relative cursor d-block fn ${
                          active ? "bgWhite" : "bgBlur text-white"
                        } mb-2 mx-1 text-center`}
                        key={index}
                        onClick={() => dashboardDetail(dash, index)}
                      >
                        {dash.dashboard_caption}
                        <span
                          onClick={() => deleteDashboard(dash.id)}
                          className="deleteIcon shadow-sm cursor bg-white position-absolute d-block text-dark text-center"
                        >
                          <i className="icon-trash-empty"></i>
                        </span>
                      </span>
                    );
                  })}
                  {/* <span className="dashbordIcon mx-2 text-center text-white cursor icon-combined-shape"
                                        style={{ fontSize: '18px' }}
                                    onClick={toggle}
                                    ></span> */}
                </div>
              </div>
            )}
            <div className="mb-2 mx-2">
              <p className="mb-1 fn12 ml-2 text-right">{t("تنظیمات")}</p>
              <div className="profileSetting m-auto">
                <div
                  className="h-50 d-flex justify-content-between align-items-center cursor px-3 py-2"
                  onClick={() => ProfileShowHideFunc("settingPage")}
                >
                  <span>
                    <i className="icon-pencil mx-2 fn12"></i>
                    <small className="fn10">{t("ویرایش اطلاعات")}</small>
                  </span>
                  <i className="icon-down-open-big fn12 rotateIcon"></i>
                </div>
                <hr className="m-0" />
                <div
                  className="h-50 d-flex justify-content-between align-items-center cursor px-3 py-2"
                  onClick={() => ProfileShowHideFunc("setting")}
                >
                  <span>
                    <i className="icon-seti mx-2 fn12"></i>
                    <small className="fn10 ">{t("تنظیمات")}</small>
                  </span>
                  <i className="icon-down-open-big fn12 rotateIcon"></i>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <HomeEdit />
      )}
      <>
        <div>
          <p className="mb-1 fn text-right">{t("کاربران")}</p>
          <div className="invitationUsers">
            {invitationList?.map((user, index) => (
              <Users key={index} user={user} />
            ))}
          </div>
        </div>
        <div
          className="d-flex justify-content-center mb-2 mt-3"
          style={{ height: "12vh" }}
        >
          <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
            <span
              className="profileAddUser bg-white d-block cursor"
              onClick={() => setOpenAddUser(!openAddUser)}
            >
              +
            </span>
            <small className="fn10 mt-1 ">{t("افزودن کاربر")}</small>
          </div>
        </div>
        {showAlert.show && (
          <Alert
            message={showAlert.message}
            type={showAlert.type}
            question={showAlert.question}
            id={showAlert.id}
            request={showAlert.request}
            toggleAlert={toggleAlert}
          />
        )}
      </>
      {/* <ShortcutModal /> */}
      {openAddUser && (
        <div className="addUserSection position-absolute bg-white w-100 px-3 text-right">
          <div
            className="cursor p-2"
            onClick={() => setOpenAddUser(!openAddUser)}
          >
            <div className="hr m-auto"></div>
          </div>
          <p className="fn12 my-2">{t("افزودن کاربر")}</p>
          {/* <div className="position-relative searchInput mb-2">
                        <input type="text" className="px-4" />
                        <i className="position-absolute">i</i>
                    </div> */}

          <Formik
            initialValues={initialValues}
            onSubmit={submitForm}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form ref={form}>
                <div className="mb-2 mt-3">
                  <input
                    type="text"
                    name="name"
                    placeholder={t("نام کاربر")}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    className="w-100 fn12 input"
                  />
                  <ErrorMessage name="name">
                    {(errMsg) => (
                      <div className="text-danger fn10 mt-1">{errMsg}</div>
                    )}
                  </ErrorMessage>
                </div>
                <div className="mb-2">
                  <input
                    type="email"
                    placeholder={t("ایمیل کاربر")}
                    name="email"
                    className="w-100 fn12 input"
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                  />
                  <ErrorMessage name="email">
                    {(errMsg) => (
                      <div className="text-danger fn10 mt-1">{errMsg}</div>
                    )}
                  </ErrorMessage>
                </div>
                <div class="d-flex flex-wrap justify-content-center mt-3 mb-5">
                  <button
                    type="submit"
                    class="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                  >
                    <span class="profileAddUser bg-white d-block icon-ok cursor"></span>
                    <small class="fn12 mt-1">{t("تائید")}</small>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* <AllUsers /> */}
        </div>
      )}
    </>
  );
};

const ProfileFirstPage = withRouter(ProfileFirstPageComp);

export { ProfileFirstPage };
